var language = {
  de: {
    ADVERTISE_WITH_BUZZFEED: 'Wirb mit BuzzFeed',
    ADVERTISE_WITH_URL: 'https://advertise.buzzfeed.com/bfdeutschland',
    ADVERTISEMENT: 'Anzeige',
    PAID_POST: 'Anzeige',
    PROMOTED_BY: 'Präsentiert von',
    PROMOTED: 'Anzeige',
    SPONSORED_BY: ''
  },
  en: {
    ADVERTISE_WITH_BUZZFEED: 'Advertise with BuzzFeed',
    ADVERTISE_WITH_URL: 'https://advertise.buzzfeed.com',
    ADVERTISEMENT: 'Advertisement',
    PAID_POST: 'Paid Post',
    PROMOTED_BY: 'Promoted By',
    PROMOTED: 'Promoted',
    SPONSORED_BY: 'Sponsored By'
  },
  es: {
    ADVERTISE_WITH_BUZZFEED: 'Anúnciate en BuzzFeed',
    ADVERTISE_WITH_URL: 'https://advertise.buzzfeed.com/bfespana',
    ADVERTISEMENT: 'Publicidad',
    PAID_POST: 'Patrocinado',
    PROMOTED_BY: 'Patrocinado por',
    PROMOTED: 'Patrocinado',
    SPONSORED_BY: 'Patrocinado por'
  },
  fr: {
    ADVERTISE_WITH_BUZZFEED: 'Annoncer sur BuzzFeed',
    ADVERTISE_WITH_URL: 'https://advertise.buzzfeed.com/bffrance',
    ADVERTISEMENT: 'Publicité',
    PAID_POST: 'Sponsorisé',
    PROMOTED_BY: 'Sponsorisé par',
    PROMOTED: 'Sponsorisé',
    SPONSORED_BY: ''
  },
  ja: {
    ADVERTISE_WITH_BUZZFEED: '',
    ADVERTISE_WITH_URL: '',
    ADVERTISEMENT: '広告',
    PAID_POST: 'Sponsored',
    PROMOTED_BY: 'Sponsored by',
    PROMOTED: 'Sponsored',
    SPONSORED_BY: 'Sponsored by'
  },
  pt: {
    ADVERTISE_WITH_BUZZFEED: '',
    ADVERTISE_WITH_URL: '',
    ADVERTISEMENT: 'Publicidade',
    PAID_POST: 'Conteúdo Pago',
    PROMOTED_BY: 'Em parceria com',
    PROMOTED: 'Patrocinado',
    SPONSORED_BY: ''
  },
  // purely for testing
  test: {
    FOO: 'Localized foo',
    ADVERTISEMENT: 'Test Advertisement',
    PROMOTED_BY: 'Test Promoted By'
  }
};

export { language as default };
